import { render, staticRenderFns } from "./UserBank.vue?vue&type=template&id=437864ba&scoped=true&"
import script from "./UserBank.vue?vue&type=script&lang=js&"
export * from "./UserBank.vue?vue&type=script&lang=js&"
import style0 from "./UserBank.vue?vue&type=style&index=0&id=437864ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437864ba",
  null
  
)

export default component.exports